import * as SignalR from "@microsoft/signalr";

export interface IConsoleMessage {
    created: string;
    message: string;
}

export default function streamConsole(
    token: string | undefined,
    taskId: string,
    onConsoleMsgReceived: Function
) {
    const tokenString: string = token ? token : "";

    const connection = new SignalR.HubConnectionBuilder()
        .withUrl("/consoleHub", { accessTokenFactory: () => tokenString })
        .withAutomaticReconnect()
        .build();

    connection.on("ReceiveMessage", data => {
        onConsoleMsgReceived(data);
    });

    return connection
        .start()
        .then(() => {
            connection
                .invoke("AddToConsoleStreamGroup", taskId)
                .catch(err => console.error(err.toString()));
        })
        .catch(err => console.error(err.toString()))
        .then(() => Promise.resolve(connection));
}
